import React, { useEffect } from 'react'
import { RootState, useAppSelector } from '../../../store'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { WelcomerState, setForWho, setWelcomers } from '../../../store/welcomerSlice'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import WelcomerProgressbar from '../../../components/v2/progrees-bars/WelcomerProgressbar'
import MovingPrice from '../../../components/v2/MovingPrice'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { AuthState } from '../../../store/authSlice'
import { useSelector } from 'react-redux'
import Message from '../../../components/Message'
import api from '../../../api'
import Loader from '../../../components/Loader'
import { Helmet } from 'react-helmet-async'
import { AppState } from '../../../store/appSlice'

const WelcomerWhoDoYouInsure = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useDispatch()
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const { filter, screenHeader, checkout } = useAppSelector((data: { welcomer: WelcomerState }) => data.welcomer)
  //
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetWelcomerPagesInfoQuery('welcomer-who-insure')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  const listItems = pageInfo?.listItems?.slice().sort((a, b) => a.sort - b.sort)
  //
  //
  // Check if at least one age is over 18
  const oneIsAdult = filter.welcomersDate && filter.welcomersDate?.map((x) => x.age)?.some((age) => age >= 18)
  //
  const LoggedUserDateIsEqual =
    checkout?.forWho === 'for-me' &&
    auth &&
    auth.user &&
    auth.user.birthday &&
    auth.user.birthday === filter.welcomersDate?.[0]?.dateFormat &&
    oneIsAdult === true &&
    filter?.welcomersDate.length === 1
      ? false
      : true
  //
  const LogOutUserDate =
    auth && !auth.user && checkout?.forWho === 'for-me' && oneIsAdult === true && filter.welcomersDate?.length === 1
      ? false
      : true
  //
  const forMeBoolean = auth && auth.user ? LoggedUserDateIsEqual : LogOutUserDate
  //
  //
  const forOtherBoolean =
    checkout?.forWho === 'for-other' && filter?.welcomersDate && filter?.welcomersDate?.length >= 1 ? false : true
  //
  const LoggedUserDateIsEqualForMeAndOther =
    checkout?.forWho === 'me-and-other' &&
    auth &&
    auth.user &&
    auth.user.birthday &&
    filter?.welcomersDate &&
    filter.welcomersDate.length >= 2 &&
    oneIsAdult === true &&
    filter.welcomersDate &&
    filter?.welcomersDate?.some((x) => x.dateFormat === auth.user?.birthday)
      ? false
      : true
  //
  const LoggedOutUserForMeAndOther =
    auth &&
    !auth.user &&
    checkout?.forWho === 'me-and-other' &&
    oneIsAdult === true &&
    filter?.welcomersDate &&
    filter.welcomersDate.length >= 2
      ? false
      : true
  //
  const forMeAndOther = auth && auth.user ? LoggedUserDateIsEqualForMeAndOther : LoggedOutUserForMeAndOther
  //
  //
  const nextButtonValidation =
    checkout?.forWho === 'for-me'
      ? forMeBoolean
      : checkout?.forWho === 'for-other'
      ? forOtherBoolean
      : checkout?.forWho === 'me-and-other'
      ? forMeAndOther
      : true
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.singleDates?.start) {
      navigate('/welcomer-start-date')
    }
    //
    return () => {}
  }, [filter.singleDates?.start, navigate])
  //
  //
  const MainLoading = isPageInfoLoading

  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <WelcomerProgressbar stepName={stepName} />

        <MovingPrice price={filter.offerTotalPrice} />

        <Cards>
          {listItems &&
            listItems?.map((item, index) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={index}
                  title={item?.translations?.[lang]?.title}
                  description={item?.translations?.[lang]?.body}
                  imgUrl={item?.image}
                  selected={item.type === checkout.forWho ? true : false}
                  onClick={() => [dispatch(setForWho(item.type)), dispatch(setWelcomers(undefined))]}
                />
              )
            })}
          {checkout.forWho === 'for-me' &&
          auth &&
          auth.user &&
          filter?.welcomersDate &&
          filter?.welcomersDate.length === 1 &&
          auth.user.birthday !== filter.welcomersDate?.[0]?.dateFormat ? (
            <Message
              style={{
                marginTop: '20px',
                marginInline: 'auto',
                maxWidth: '464px',
              }}
              variant="gray"
              text="დალოგინებული მომხმარებლის დაბადების თარიღი არ ემთხვევა თქვენს მიერ შეყვანილ თარიღს !"
            />
          ) : null}

          {checkout.forWho === 'me-and-other' &&
          auth &&
          auth.user &&
          filter?.welcomersDate &&
          filter?.welcomersDate.length >= 2 &&
          LoggedUserDateIsEqualForMeAndOther === true ? (
            <Message
              style={{
                marginTop: '20px',
                marginInline: 'auto',
                maxWidth: '464px',
              }}
              variant="gray"
              text="დალოგინებული მომხმარებლის დაბადების თარიღი არ ემთხვევა თქვენს მიერ შეყვანილ არცერთ თარიღს !"
            />
          ) : null}
        </Cards>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/welcomer-offer')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={nextButtonValidation}
            onClick={() => {
              navigate(
                checkout.forWho === 'for-me'
                  ? '/welcomer-for-me'
                  : checkout.forWho === 'for-other'
                  ? '/welcomer-for-other'
                  : checkout.forWho === 'me-and-other'
                  ? '/welcomer-for-me-and-other'
                  : '',
              )
            }}
          />
        </Buttons>
      </Content>
      <BackgroundIcon />
    </Wrapper>
  )
}

//
//
//
// styles
const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0px;
  place-items: center;
  grid-row-gap: 24px;
  margin-top: 32px;

  ${Responsive.mobile} {
    margin-top: 24px;
    grid-row-gap: 20px;
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`

export default WelcomerWhoDoYouInsure
